var map = {
	"./dwnsl/xuebitu.jpg": "2203",
	"./jhgwl/xuebitu.jpg": "3775",
	"./jxyyl/xuebitu.jpg": "a8ea",
	"./shqwl/xuebitu.jpg": "2a9b",
	"./txdsl/xuebitu.jpg": "38d3",
	"./wzzsl/xuebitu.jpg": "baa9",
	"./xdtal/xuebitu.jpg": "e6c9",
	"./zwhcl/xuebitu.jpg": "ea5a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fe6f";